import React, {useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux";
import Login from "./Login";
import {AUTHENTICATED, NOT_AUTHENTICATED, setEvent, setServices} from "../slices/sessionSlice";
import {AlertTitle} from "@mui/material";
import {Alert} from "@mui/material";
import Container from "@mui/material/Container";
import {useLazyGetUserEventServicesQuery} from "../slices/apiSlice";

const defaultNotAuthorizedView =
    <Container maxWidth={'xs'} sx={{mt:'30vh', textAlign:'left'}}>
        <Alert severity="error">
            <AlertTitle>Not found</AlertTitle>
            The requested resource was not found or you are not authorized to view it
        </Alert>
    </Container>


export default function Authenticated({children, notAuthenticatedView =  <Login modal/>, notAuthorizedView = defaultNotAuthorizedView, scopes}){
    const session = useSelector(state => state.session)
    const dispatch = useDispatch()

    const [getServices,getServicesResult] = useLazyGetUserEventServicesQuery()

    const hasScope = scopes ? session.user && session.user.scopes && session.user.scopes.find(scope => scopes.includes(scope)) !== undefined : true

    useEffect(() => {
        if (session.status === AUTHENTICATED) {
            getServices()
        }

    }, [session.status]);

    useEffect(() => {
        if (getServicesResult.isSuccess) {
            dispatch(setServices(getServicesResult.data))
        }
    }, [getServicesResult.isSuccess]);


    return (
        <>
            {
                session.status === AUTHENTICATED && hasScope ?
                    children
                    :
                    session.status === AUTHENTICATED && !hasScope  ?
                        notAuthorizedView
                        :
                        notAuthenticatedView
            }
        </>
    )
}